import { useRequest } from 'features/request/useRequest';
import { useResetStoreData } from 'features/request/useResetStoreData';

import { useEffect, useMemo } from 'react';

import { uerActKC2OtherPriceItemsGql } from '../../workOrderQueries';

const requestId = 'uerActKC2OtherPriceItems';

export const useUerActKC2OtherPriceItems = (actKC2Id?: number) => {
    const [uerActKC2OtherPriceItemsReset] = useResetStoreData({ requestId });

    const variables = useMemo(() => ({ actKC2Id }), [actKC2Id]);

    const [uerActKC2OtherPriceItemsData, uerActKC2OtherPriceItemsStatus] = useRequest({
        requestId,
        query: uerActKC2OtherPriceItemsGql,
        variables,
        withEffect: !!actKC2Id,
    });

    useEffect(() => {
        uerActKC2OtherPriceItemsReset(undefined);
    }, [uerActKC2OtherPriceItemsReset]);

    const items = useMemo(
        () => uerActKC2OtherPriceItemsData?.uerActKC2OtherPriceItems?.items || [],
        [uerActKC2OtherPriceItemsData?.uerActKC2OtherPriceItems?.items],
    );

    return {
        items,
        status: uerActKC2OtherPriceItemsStatus,
    };
};
